module.exports = __webpack_public_path__ + "static/media/arrowRightDate.f52c39d2.svg";